<template>
  <div style="position: relative;">
    <gmap-map
        v-bind="$attrs"
        :center="centerLocal"
        style="width: 100%; height: 320px"
        @click="mapClick"
    >
      <gmap-marker
          v-if="marker"
          :position="(marker || {}).latLng"
          @click="markerClick"
      ></gmap-marker>
    </gmap-map>
    <!-- style="position: absolute; bottom: 3px; left: 3px; height: 20px; width: 200px" -->
    <gmap-autocomplete
        class="gmap-autocomplete"
        select-first-on-enter
        @place_changed="onPlaceChanged"
    ></gmap-autocomplete>
  </div>
</template>

<script>
export default {
  model: {
    event: 'input'
  },
  inheritAttrs: false,
  props: {
    value: [String],
    center: {
      type: Object,
      default() { return {} }
    },
    disabled: {
      type: Boolean,
      default(){
        return false;
      }
    }
  },
  data() {
    return {
      centerLocal: this.center,
      marker: null
    }
  },
  watch: {
    center(value, valueBefore) {
      if (!this.lodash.isEqual(value, valueBefore))
        this.centerLocal = value;
    },
    value: {
      handler(value) {
        const [ lat, lng ] = (value || '').split(',');
        if (lat && lng)
          this.marker = { latLng: { lat: Number(lat), lng: Number(lng) } };
      },
      immediate: true
    },
    marker(value) {
      if (value)
        this.$emit('input', `${value.latLng.lat},${value.latLng.lng}`);
      else
        this.$emit('input', null);
    }
  },
  methods: {
    mapClick(event) {
      if(this.disabled) return;
      this.marker = {
        latLng: {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        }
      };
    },
    markerClick() {      
      this.marker = null;
    },
    onPlaceChanged(event) {
      this.centerLocal = {
        lat: event.geometry.location.lat(),
        lng: event.geometry.location.lng()
      }
      this.$nextTick(() => {
        this.marker = {
          latLng: {
            lat: event.geometry.location.lat(),
            lng: event.geometry.location.lng()
          }
        };
      })
    }
  }
}
</script>

<style scoped lang="scss">
  
</style>